import { Navigate, useRoutes } from 'react-router-dom';
import MainLayout from '../layouts/main';
// config
//
import { HomePage, Page404 } from './elements';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      element: <MainLayout />,
      children: [{ path: '404', element: <Page404 /> }],
    },
    {
      element: <MainLayout />,
      children: [{ path: '/', element: <HomePage /> }],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
